export enum RasterLayerType {
    MOISTURE_STATUS = "moisture_status",
    NDVI = "ndvi",
    SOIL_MOISTURE_ROOT_ZONE = "soil_moisture_root_zone_today",
    SOIL_WATER_POTENTIAL_ROOT_ZONE = "soil_water_potential_root_zone",
    ACTUAL_EVAPOTRASPIRATION = "actual_evapotranspiration",
    DRY_MATTER_PRODUCTION = "actual_crop_production",
    DRY_MATTER_PRODUCTION_CUMULATIVE = "crop_production_cumulative",
    LEAF_NITROGEN = "n_leaf_percentage",
    SOIL_TEMPERATURE_DAILY_0CM = "soil_temperature",
    ACTUAL_EVAPOTRASPIRATION_APPLIED_WATER_CUMULATIVE = "actual_evapotranspiration_applied_water_cumulative",
    CANE_MOISTURE_CONTENT = "moisture_content_cane",
    CANE_SUGER_CONTENT = "sugar_content_cane",
    LEAF_TEMPERATURE = "leaf_temperature_inst",
    NONE = "none",
}
